<template>
    <el-container id="sintomas">
      <el-row :md="24" class="long hidden-sm-and-down"  >
      <div class="timeline" :class="{timelined :scrollPosition >690, untimed:scrollPosition > 2250}" >
        <img src="@/assets/nofill.png" class="vacio" :class="{lleno:scrollPosition > 900}" alt="">
        <img src="@/assets/nofill.png" class="vacio" :class="{lleno:scrollPosition > 1200}" alt="">
        <img src="@/assets/nofill.png" class="vacio" :class="{lleno:scrollPosition > 1600}" alt="">
        <img src="@/assets/nofill.png" class="vacio" :class="{lleno:scrollPosition > 2000}" alt="">
      </div>
      <div class="stay"  >
        <img src="@/assets/diagnostico.png" class="diagnos hidden-sm-and-down" alt="">
        <el-row wrap class="text-center verse" :class="{noverse: scrollPosition > 690}" style="">
          <el-col :lg="11" :md="10" :sm="24" >
            <div class=" py3 sintomas">Principales Síntomas</div>
          </el-col>
          <el-col  :lg="10" :md="10" :sm="22" class="el-col-sm-offset-1">
            <div class="eror" >Este error genético condiciona 
              la aparición de rasgos característicos en los pacientes, los más representativos son: 
            </div>
          </el-col>
        </el-row>
        <el-row wrap class="principales">
          <img src="@/assets/diagnostico.png" class="hidden-md-and-up diag" alt="">
         <transition-group name="fade" mode="out-in">
            <el-col :md="12" class="ununo" :class="{uno:scrollPosition >600}">
            <p class="auditivo"><span>Problemas auditivos</span><br>
              (Disminución auditiva <br>
              o infecciones del oído medio)</p>
            <img src="@/assets/audicion.png" alt="">
            </el-col>
            <el-col :md="12" class="undos" :class="{dos:scrollPosition > 1200}">
              <p class="dismorfia"><span>Dismorfia facial</span><br>
            (Rasgos toscos o asimétricos <br> de la cara)
            </p>
            <img src="@/assets/dismorfia.png" alt="">
            </el-col>
          <el-col :md="12" class="untres" :class="{dos:scrollPosition > 1600}">
                <p class="eskeleto"><span>Anomalías esqueléticas</span><br>
              (Deformación o problemas <br> óseos)</p>
            <img src="@/assets/motoras.png" alt="">
            <p class="eskeleto1"><span>Dificultades motoras</span> <br> 
            (Incapacidad para <br>
            la deambulación)</p>
          </el-col>
          <el-col :md="12" class="uncuatro" :class="{cuatro:scrollPosition > 2000}">
              <p class="cerebro"><span>Compromiso del SNC</span><br>
            (Discapacidad intelectual o <br> trastornos mentales)
            </p>
            <img src="@/assets/cerebro.png" alt="">
            <p class="cerebro1"><span>Pacientes dependientes</span></p>
          </el-col>
         </transition-group>
        </el-row>
        <div class="box uncuatro"  :class="{cuatro:scrollPosition > 2100}" @click="scrollPageToo()">
          <img src="@/assets/vermas.png"  alt="">
          <p class="verMas">Más</p>
        </div>
      </div>
    </el-row>
    <el-row :md="24" class=" hidden-md-and-up"  >
      <div >
        <img src="@/assets/diagnostico.png" class="diagnos hidden-sm-and-down" alt="">
        <el-row wrap class="text-center" style="">
          <el-col :lg="11" :md="13" :sm="24" >
            <div class=" py3 sintomas">Principales Síntomas</div>
          </el-col>
          <el-col  :lg="12" :md="10" :sm="22" :xs="22" class="el-col-sm-offset-1 el-col-xs-offset-1">
            <div class="eror" >Este error genético condiciona 
              la aparición de rasgos característicos en los pacientes, los más representativos son: 
            </div>
          </el-col>
        </el-row>
        <el-row wrap class="principales">
          <img src="@/assets/diagnostico.png" class="hidden-md-and-up diag" alt="">
         <transition-group name="fade" mode="out-in">
            <el-col :md="12" class="ununo" :class="{uno:scrollPosition > 800}">
            <p class="auditivo"><span>Problemas auditivos</span><br>
              (Disminución auditiva <br>
              o infecciones del oído medio)</p>
            <img src="@/assets/audicion.png" alt="">
            </el-col>
            <el-col :md="12" class="ununo" :class="{uno:scrollPosition > 1100}">
              <p class="dismorfia"><span>Dismorfia facial</span><br>
            (Rasgos toscos o asimétricos <br> de la cara)
            </p>
            <img src="@/assets/dismorfia.png" alt="">
            </el-col>
          <el-col :md="12" class="ununo" :class="{uno:scrollPosition > 1400}">
                <p class="eskeleto"><span>Anomalías esqueléticas</span><br>
              (Deformación o problemas <br> óseos)</p>
            <img src="@/assets/motoras.png" alt="">
            <p class="eskeleto1"><span>Dificultades motoras</span> <br> 
            (Incapacidad para <br>
            la deambulación)</p>
          </el-col>
          <el-col :md="12" class="ununo" :class="{uno:scrollPosition > 1800}">
              <p class="cerebro"><span>Compromiso del SNC</span><br>
            (Discapacidad intelectual o <br> trastornos mentales)
            </p>
            <img src="@/assets/cerebro.png" alt="">
            <p class="cerebro1"><span>Pacientes dependientes</span></p>
          </el-col>
         </transition-group>
        </el-row>
        <div class="ununo box" @click="scrollPageToo()" :class="{uno:scrollPosition > 1800}">   
          <img src="@/assets/vermas.png" alt="">
          <p class="verMas">Más</p>
        </div>
      </div>
    </el-row>
    </el-container>
</template>
<script>
import { onBeforeMount, onMounted, } from 'vue'
import { watch, ref, computed } from 'vue'
import { useStore } from 'vuex'
import 'element-plus/lib/theme-chalk/display.css';

export default {
    name:'Sintomas',
    props:['index'],
    setup() {
       const store = useStore()
       const checkSintomas = computed(() => store.state.checkSintomas)   
       const symptom = () => store.commit('symptom')
 
       const scrollPosition = ref(null)
       const x = ref(null)
       const uno = ref(false)
       const unom = ref(false)
       const dos = ref(false)
       const dosm = ref(false)
       const tres = ref(false)
       const tresm = ref(false)
       const cuatro = ref(false)
       const cuatrom = ref(false)
        let updateScroll = () => {
        scrollPosition.value = window.scrollY;
        }
        let getWidth = () =>{
          x.value = screen.width
        }
        onBeforeMount(() => window.addEventListener("load",getWidth))
         onMounted(() => window.addEventListener("scroll", updateScroll))
         watch(scrollPosition,() => {
            if(scrollPosition.value > 1800){
             cuatrom.value = true
             if(x.value < 768){
               symptom() 
              }
             }
            
           if(scrollPosition.value >2400){
             symptom()
             }
         } )
         
         
   const scrollPageToo = () => {
     if(screen.width < 769){
      window.scrollTo({top:2660, behavior:'smooth'})
      console.log("wata")
     }else{
     window.scrollTo({top:3010, behavior:'smooth'})
     }
  }
        
        return {scrollPageToo , updateScroll, scrollPosition, 
        uno, unom, dos, dosm, tres, tresm, cuatro, cuatrom,
        x,checkSintomas}
    }
}
</script>
<style lang="scss" scoped>
 .long{
    display: block;
    margin-top: 0px;
    width: 100vw;
    height: 2200px;
    }
 #sintomas{
   margin-top: 140px;
 }

 
 .short{
   height: 2350px ;
 
   }
  .stay{
    position: -webkit-sticky !important;
    position: sticky;
    top: 200px;
  }
 .quieto{
   width: 100%;
 }
 .noquieto{
   position: relative !important;
  top: 1550px !important;
  
 }
 .ununo , .undos, .untres, .uncuatro{
   position: sticky;
   opacity:  0;
   transition: 0.5s all ease-in-out;
   -o-transition: all 0.5s ease;
   -moz-transition: all 0.5s ease;
   -webkit-transition: all 0.5s ease;
 }
 .uno, .dos, .tres, .cuatro{
   opacity: 1; 
   transition: 0.5s all ease-in-out;
   -o-transition: all 0.5s ease;
   -moz-transition: all 0.5s ease;
   -webkit-transition: all 0.5s ease;
 
 }
 .vacio{
   border-radius: 50%;
    transition: visibility 0.8s linear;
    -o-transition: all 0.8s ease;
   -moz-transition: all 0.8s ease;
   -webkit-transition: all 0.8s ease;
 

 }
 .lleno{
   background-color: #005D45;

 }
 .opacidad {
  opacity: 0;
}
.opacidad_on {
  opacity: 1;
}
 .cajas{
    background-color: red;
  width: 400px;
  border: 1px solid #000;
  height: 200px;
  margin: 1rem auto;
 } 
.sintomas{
    font-family: 'Yusei-Magic';
    font-weight: 400;
    font-size: 48px;
    color: #005D45;
  }
  .eror{
    margin-top: 10px;
    font-size: 18px;
    font-family: "Avenir";
    line-height: 30px;
    text-align: right;
  }
  .principales{
    line-height: 20px;
    color :#000D5A;
    font-size: 18px;
  }
  .principales img{
    width: 25%;
    height: auto;
  }
  .diagnos{
    position: absolute;
    z-index: 100;
    transform: translate(-50%, 150%);
  }
  .timeline{
    display: inline-grid;
    position: absolute;
    right: 50px;
    top: 460px;
  }
  .timelined{
    display: inline-grid;
    position: fixed;
    right: 50px;
    top: 50%;
  }
  .untimed{
    position: absolute;
    top: 220px
    
  }
  .timeline img{
    margin: 15px;
  }
  .auditivo{
    margin-left: 310px;
    margin-bottom: 15px;
    text-align:left;
  }
  .dismorfia{
    text-align: right;
    margin-right: 290px;
    margin-bottom: 10px;
  }
  .eskeleto1{
    margin-left: 410px;
    text-align: left;
  }
  .cerebro1 {
    margin-top: 20px;
    margin-right: 250px;
  }
  .auditivo span, .dismorfia span, .eskeleto span, .eskeleto1 span, .cerebro span, .cerebro1 span{
    font-weight: 600;
  }
  .box{
    margin-bottom: 100px;
    
  }
  .box img{
    cursor: pointer;
  }
  .box p{
  position: absolute;
  padding-bottom: 140px;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  font-family: "Yusei-Magic";
  }
  /*transiciones*/
  .fade-enter-from{
    opacity: 0;
    transform: scale((0.8));
  }
  .fade-enter-to{
    opacity: 1;
    transform: scale(1);
  }
  .fade-enter-active{
    transition: all 0.6s ease;
  }
  .diag{
    margin: auto;
  }
  @media (max-width:768px) {
    .eror{
      text-align: center;
    }
    .eskeleto1{
      margin: 0;
      text-align: center;
    }
    .cerebro1{
      margin: 0;
      text-align: center;
    }
    .quieto{
   top: 10%;
 }
  .box{
    margin-top: 20px;
  }
  }
  @media(max-width:1400px){
    .stay{
      top:150px
    }
    .sintomas{
      font-size:38px;
    }
    .diagnos{
      width:10%;
      transform: translate(-50%, 100%);
    }
    .principales img{
      width:20%
    }
    .principales{
      font-size:12px
    }
    .eskeleto{
      margin:0
    }
    .cerebro{
      margin:0
    }
    .box{
      margin-top:-80px
    }  
  }
  .box{
    margin-top: 10px;
  }
  @media (max-width:500px) {
    .sintomas{
      font-size: 35px;
    }
    .principales img{
      width: 60%;
    }
    .auditivo{
      margin-left: 0;
      text-align: center;
    }
    .dismorfia{
      margin-right: 0;
      text-align: center;
    }
    #sintomas{
      margin-top: 175px;
    }
    .box{
      margin-top: 0;
      margin-bottom: 30px;
    }
  }
</style>